import React, { Fragment } from 'react'
import { useLocation } from 'react-router-dom';

const ScopeTab = ({ formik }: any) => {
    const location = useLocation();
    const isReadOnly = location.pathname.includes('/projects/view-project');
    return (
        <>
            <div className='row'>
                <h5 className='mb-2 mt-2'>Opportunity Scope</h5>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Revised
                                </p>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsScopeDTO?.opportunityScop.slice(0, 4).map((opportunityScop: any, index: any) => (
                                <Fragment key={index}>
                                    {opportunityScop?.fieldType === "Option" ?
                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                            <p className="mb-0">{opportunityScop?.name}</p>
                                            <div className="d-flex gap-5">
                                                <label className="checkboxs positionCheckBox">

                                                    <input
                                                        type="checkbox"
                                                        disabled={isReadOnly}
                                                        checked={opportunityScop.surveyResultRevised === '2'}
                                                        onChange={() => {
                                                            formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultRevised`, opportunityScop.surveyResultRevised === '2' ? '0' : '2'); // Toggle logic
                                                        }}
                                                    />
                                                    <span className="checkmarks mt-1" />
                                                </label>
                                                <label className="checkboxs positionCheckBox">

                                                    <input
                                                        type="checkbox"
                                                        disabled={isReadOnly}
                                                        checked={opportunityScop.surveyResultOriginal === '1'}
                                                        onChange={() => {
                                                            formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultOriginal`, opportunityScop.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                        }}
                                                    />
                                                    <span className="checkmarks mt-1" />
                                                </label>
                                            </div>
                                        </div>
                                        : opportunityScop?.fieldType === "Numeric" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0 w-50">{opportunityScop?.name}</p>
                                                <div className="d-flex gap-3 w-50 justify-content-end">
                                                    <div className='d-flex gap-2 align-items-center'>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            style={{ width: 50 }}
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultRevised`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultRevised`, e.target.value.toString())}
                                                        />
                                                        <label></label>

                                                    </div>
                                                    <div className='d-flex gap-2 align-items-center'>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            style={{ width: 50 }}
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultOriginal`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultOriginal`, e.target.value.toString())}
                                                        />


                                                    </div>
                                                </div>
                                            </div>
                                            : opportunityScop?.fieldType === "Text" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{opportunityScop?.name}</p>
                                                    <div className="d-flex gap-2 w-50">
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                style={{ width: 50 }}
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultRevised`)}
                                                            />
                                                            <label></label>

                                                        </div>
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                style={{ width: 50 }}
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${index}].surveyResultOriginal`)}
                                                            />
                                                            <label>  </label>

                                                        </div>

                                                    </div>
                                                </div>
                                                : null
                                    }
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Revised
                                </p>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsScopeDTO?.opportunityScop.slice(4, 8).map((opportunityScop: any, index: any) => {
                                const actualIndex = index + 4; // Adjust index to reflect the actual position in the array

                                return (
                                    <Fragment key={actualIndex}>
                                        {opportunityScop?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0">{opportunityScop?.name}</p>
                                                <div className="d-flex gap-5">
                                                    <label className="checkboxs positionCheckBox">

                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={opportunityScop.surveyResultRevised === '2'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultRevised`, opportunityScop.surveyResultRevised === '2' ? '0' : '2'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                    <label className="checkboxs positionCheckBox">

                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={opportunityScop.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultOriginal`, opportunityScop.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : opportunityScop?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{opportunityScop?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                style={{ width: 150 }}
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultRevised`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultRevised`, e.target.value.toString())}
                                                            />
                                                            <label></label>

                                                        </div>
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                style={{ width: 150 }}
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultOriginal`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                            />


                                                        </div>
                                                    </div>
                                                </div>
                                                : opportunityScop?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{opportunityScop?.name}</p>
                                                        <div className="d-flex gap-2 w-50">
                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    style={{ width: 150 }}
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultRevised`)}
                                                                />
                                                                <label></label>

                                                            </div>
                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    style={{ width: 150 }}
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.opportunityScop[${actualIndex}].surveyResultOriginal`)}
                                                                />
                                                                <label>  </label>

                                                            </div>

                                                        </div>
                                                    </div>
                                                    : null
                                        }
                                    </Fragment>
                                );
                            })}

                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <h5 className='mb-2 mt-2'>Addition Scope</h5>

                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Revised
                                </p>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsScopeDTO?.additionScope.slice(0, 8).map((additionScope: any, index: any) => (
                                <Fragment key={index}>
                                    {additionScope?.fieldType === "Option" ?
                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                            <p className="mb-0">{additionScope?.name}</p>
                                            <div className="d-flex gap-5">
                                                <label className="checkboxs positionCheckBox">

                                                    <input
                                                        type="checkbox"
                                                        disabled={isReadOnly}
                                                        checked={additionScope.surveyResultRevised === '2'}
                                                        onChange={() => {
                                                            formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultRevised`, additionScope.surveyResultRevised === '2' ? '0' : '2'); // Toggle logic
                                                        }}
                                                    />
                                                    <span className="checkmarks mt-1" />
                                                </label>
                                                <label className="checkboxs positionCheckBox">

                                                    <input
                                                        type="checkbox"
                                                        disabled={isReadOnly}
                                                        checked={additionScope.surveyResultOriginal === '1'}
                                                        onChange={() => {
                                                            formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultOriginal`, additionScope.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                        }}
                                                    />
                                                    <span className="checkmarks mt-1" />
                                                </label>
                                            </div>
                                        </div>
                                        : additionScope?.fieldType === "Numeric" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0 w-50">{additionScope?.name}</p>
                                                <div className="d-flex gap-3 w-50 justify-content-end">
                                                    <div className='d-flex gap-2 align-items-center'>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            style={{ width: 150 }}
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultRevised`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultRevised`, e.target.value.toString())}
                                                        />
                                                        <label></label>

                                                    </div>
                                                    <div className='d-flex gap-2 align-items-center'>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            style={{ width: 150 }}
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultOriginal`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultOriginal`, e.target.value.toString())}
                                                        />


                                                    </div>
                                                </div>
                                            </div>
                                            : additionScope?.fieldType === "Text" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{additionScope?.name}</p>
                                                    <div className="d-flex gap-2 w-50">
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultRevised`)}
                                                            />
                                                            <label></label>

                                                        </div>
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${index}].surveyResultOriginal`)}
                                                            />
                                                            <label>  </label>

                                                        </div>

                                                    </div>
                                                </div>
                                                : null
                                    }
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Revised
                                </p>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsScopeDTO?.additionScope.slice(8, 16).map((additionScope: any, index: any) => {
                                const actualIndex = index + 8; // Adjust index to reflect the actual position in the array

                                return (
                                    <Fragment key={actualIndex}>
                                        {additionScope?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0">{additionScope?.name}</p>
                                                <div className="d-flex gap-5">
                                                    <label className="checkboxs positionCheckBox">

                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={additionScope.surveyResultRevised === '2'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultRevised`, additionScope.surveyResultRevised === '2' ? '0' : '2'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                    <label className="checkboxs positionCheckBox">

                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={additionScope.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultOriginal`, additionScope.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : additionScope?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{additionScope?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                style={{ width: 50 }}
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultRevised`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultRevised`, e.target.value.toString())}
                                                            />
                                                            <label></label>

                                                        </div>
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                style={{ width: 50 }}
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultOriginal`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                            />


                                                        </div>
                                                    </div>
                                                </div>
                                                : additionScope?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{additionScope?.name}</p>
                                                        <div className="d-flex gap-2 w-50">
                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    style={{ width: 50 }}
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultRevised`)}
                                                                />
                                                                <label></label>

                                                            </div>
                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    style={{ width: 50 }}
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.additionScope[${actualIndex}].surveyResultOriginal`)}
                                                                />
                                                                <label>  </label>

                                                            </div>

                                                        </div>
                                                    </div>
                                                    : null
                                        }
                                    </Fragment>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <h5 className='mb-2 mt-2'>Detailed Scope</h5>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Revised
                                </p>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsScopeDTO?.detailedScope.slice(0, 11).map((detailedScope: any, index: any) => (
                                <Fragment key={index}>
                                    {detailedScope?.fieldType === "Option" ?
                                        <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                            <p className="mb-0">{detailedScope?.name}</p>
                                            <div className="d-flex gap-5">
                                                <label className="checkboxs positionCheckBox">

                                                    <input
                                                        type="checkbox"
                                                        disabled={isReadOnly}
                                                        checked={detailedScope.surveyResultRevised === '2'}
                                                        onChange={() => {
                                                            formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultRevised`, detailedScope.surveyResultRevised === '2' ? '0' : '2'); // Toggle logic
                                                        }}
                                                    />
                                                    <span className="checkmarks mt-1" />
                                                </label>
                                                <label className="checkboxs positionCheckBox">

                                                    <input
                                                        type="checkbox"
                                                        disabled={isReadOnly}
                                                        checked={detailedScope.surveyResultOriginal === '1'}
                                                        onChange={() => {
                                                            formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultOriginal`, detailedScope.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                        }}
                                                    />
                                                    <span className="checkmarks mt-1" />
                                                </label>
                                            </div>
                                        </div>
                                        : detailedScope?.fieldType === "Numeric" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0 w-50">{detailedScope?.name}</p>
                                                <div className="d-flex gap-3 w-50 justify-content-end">
                                                    <div className='d-flex gap-2 align-items-center'>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            // style={{ width: 100 }}
                                                            className='w-100'
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultRevised`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultRevised`, e.target.value.toString())}
                                                        />
                                                        <label></label>

                                                    </div>
                                                    <div className='d-flex gap-2 align-items-center'>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            className='w-100'
                                                            // style={{ width: 100 }}
                                                            disabled={isReadOnly}
                                                            {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultOriginal`)}
                                                            onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultOriginal`, e.target.value.toString())}
                                                        />


                                                    </div>
                                                </div>
                                            </div>
                                            : detailedScope?.fieldType === "Text" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{detailedScope?.name}</p>
                                                    <div className="d-flex gap-2 w-50">
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultRevised`)}
                                                            />
                                                            <label></label>

                                                        </div>
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${index}].surveyResultOriginal`)}
                                                            />
                                                            <label>  </label>

                                                        </div>

                                                    </div>
                                                </div>
                                                : null
                                    }
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card border-gray h-100">
                        <div className="card-body p-2">
                            <div className='d-flex gap-3 justify-content-end mb-2'>
                                <p className='mb-0 fw-600'>
                                    Revised
                                </p>
                                <p className='mb-0 fw-600'>
                                    Original
                                </p>
                            </div>
                            {formik.values?.opportunityDetailsScopeDTO?.detailedScope.slice(11, 22).map((detailedScope: any, index: any) => {
                                const actualIndex = index + 11; // Adjust index to reflect the actual position in the array
                                return (
                                    <Fragment key={actualIndex}>
                                        {detailedScope?.fieldType === "Option" ?
                                            <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                <p className="mb-0">{detailedScope?.name}</p>
                                                <div className="d-flex gap-5">
                                                    <label className="checkboxs positionCheckBox">

                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={detailedScope.surveyResultRevised === '2'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultRevised`, detailedScope.surveyResultRevised === '2' ? '0' : '2'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                    <label className="checkboxs positionCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            disabled={isReadOnly}
                                                            checked={detailedScope.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultOriginal`, detailedScope.surveyResultOriginal === '1' ? '0' : '1'); // Toggle logic
                                                            }}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            : detailedScope?.fieldType === "Numeric" ?
                                                <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                    <p className="mb-0 w-50">{detailedScope?.name}</p>
                                                    <div className="d-flex gap-3 w-50 justify-content-end">
                                                        <div className='d-flex gap-3 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultRevised`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultRevised`, e.target.value.toString())}
                                                            />
                                                            <label></label>

                                                        </div>
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className='w-100'
                                                                disabled={isReadOnly}
                                                                {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultOriginal`)}
                                                                onChange={(e) => formik.setFieldValue(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                : detailedScope?.fieldType === "Text" ?
                                                    <div className={`d-flex justify-content-between align-items-center mb-2`}>
                                                        <p className="mb-0 w-50">{detailedScope?.name}</p>
                                                        <div className="d-flex gap-3 w-50">
                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    className='w-100'
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultRevised`)}
                                                                />
                                                            </div>
                                                            <div className='d-flex gap-2 align-items-center'>
                                                                <input
                                                                    type="text"
                                                                    className='w-100'
                                                                    disabled={isReadOnly}
                                                                    {...formik.getFieldProps(`opportunityDetailsScopeDTO.detailedScope[${actualIndex}].surveyResultOriginal`)}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    : null
                                        }
                                    </Fragment>
                                );
                            })}

                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-12 d-flex justify-content-end '>
                <div className='mt-2 bg-red text-redd position-fixed bottom-0 px-2 rounded' style={{ right: "0px", zIndex: 1 }}><i>Created at 11/17/2023 by Ann Marie.01:00:22 PM Last modified at 11/17/2023 01:00:22 PM by Maxx Klein.</i></div>
            </div>
        </>
    )
}

export default ScopeTab